var isWeb = typeof window !== 'undefined' && typeof document !== 'undefined';
typeof wx !== 'undefined' && typeof wx.getSystemInfo === 'function';

var createLogger = function createLogger() {
  var logDisabled = false;
  var changeLogStatus = function changeLogStatus(s) {
    logDisabled = s;
  };
  return {
    green: function green(info) {
      var _console;
      for (var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        rest[_key - 1] = arguments[_key];
      }
      logDisabled && (_console = console).log.apply(_console, ["%c".concat(info), 'color: green; font-size: 14px'].concat(rest));
    },
    red: function red(info) {
      var _console2;
      for (var _len2 = arguments.length, rest = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        rest[_key2 - 1] = arguments[_key2];
      }
      logDisabled && (_console2 = console).log.apply(_console2, ["%c".concat(info), 'color: red; font-size: 14px'].concat(rest));
    },
    log: function log(info) {
      var _console3;
      for (var _len3 = arguments.length, rest = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
        rest[_key3 - 1] = arguments[_key3];
      }
      logDisabled && (_console3 = console).log.apply(_console3, [info].concat(rest));
    },
    warn: function warn(info) {
      var _console4;
      for (var _len4 = arguments.length, rest = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
        rest[_key4 - 1] = arguments[_key4];
      }
      logDisabled && (_console4 = console).warn.apply(_console4, [info].concat(rest));
    },
    error: function error(info) {
      var _console5;
      for (var _len5 = arguments.length, rest = new Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
        rest[_key5 - 1] = arguments[_key5];
      }
      logDisabled && (_console5 = console).error.apply(_console5, [info].concat(rest));
    },
    changeLogStatus: changeLogStatus
  };
};
var logger = createLogger();

var getPvEvent = function getPvEvent() {
  return {
    event_type_code: 'Page_View',
    event_properties: {
      url: location.href,
      host: location.host,
      path: location.pathname
    }
  };
};
/**
 * @description page view [浏览器]插件，监听URL的变化来发送PV
 * @param options.monitorHash 是否监控hash变化
 * @param options.monitorPush 是否监控pushState
 * @param options.monitorPop 是否监控popState
 * @param options.monitorReplace 是否监控replaceState
 * @returns {ITrackPluginConstructor} TrackPluginConstructor
 */
var pageViewPlugin = function pageViewPlugin(options) {
  return function (_, client) {
    if (!isWeb) {
      return {
        name: 'page-view'
      };
    }
    var _ref2 = options || {},
      _ref2$monitorHash = _ref2.monitorHash,
      monitorHash = _ref2$monitorHash === void 0 ? false : _ref2$monitorHash,
      _ref2$monitorPush = _ref2.monitorPush,
      monitorPush = _ref2$monitorPush === void 0 ? true : _ref2$monitorPush,
      _ref2$monitorPop = _ref2.monitorPop,
      monitorPop = _ref2$monitorPop === void 0 ? true : _ref2$monitorPop,
      _ref2$monitorReplace = _ref2.monitorReplace,
      monitorReplace = _ref2$monitorReplace === void 0 ? true : _ref2$monitorReplace;
    var lastLocation = isWeb ? window.location : '';
    var timer;
    var popStateHandler;
    var hashChangeHandler;
    return {
      name: 'page-view',
      init: function init() {
        logger.log('[plugin] page-view inited!');
        if (isWeb) {
          // Initial PV
          var event = getPvEvent();
          client.track(event);
          if (monitorPop) {
            popStateHandler = function popStateHandler() {
              if (lastLocation === location.href) return;
              // avoiding triggered by hashchange
              timer = setTimeout(function () {
                lastLocation = location.href;
                var event = getPvEvent();
                client.track(event);
                logger.log('pagev-view:pop', location.href);
              }, 10);
            };
            window.addEventListener('popstate', popStateHandler);
          }
          if (monitorReplace) {
            var originalReplaceState = window.history.replaceState;
            window.history.replaceState = function () {
              for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
                args[_key] = arguments[_key];
              }
              originalReplaceState.apply(window.history, args);
              var event = getPvEvent();
              client.track(event);
              logger.log('[page-view:replace]', window.location.href);
            };
          }
          if (monitorPush) {
            var originalPushState = window.history.pushState;
            window.history.pushState = function () {
              for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
                args[_key2] = arguments[_key2];
              }
              originalPushState.apply(window.history, args);
              var event = getPvEvent();
              client.track(event);
              logger.log('[page-view:push]', window.location.href);
            };
          }
          hashChangeHandler = function hashChangeHandler() {
            if (lastLocation === location.href) return;
            clearTimeout(timer);
            if (monitorHash) {
              var _event = getPvEvent();
              client.track(_event);
              logger.log('[page-view:hash]', location.href);
            }
          };
          window.addEventListener('hashchange', hashChangeHandler);
        }
      },
      destroy: function destroy() {
        if (!isWeb) return;
        popStateHandler && window.removeEventListener('popstate', popStateHandler);
        hashChangeHandler && window.removeEventListener('hashchange', hashChangeHandler);
      }
    };
  };
};
// const pageViewPlugin = () => {
//   // https://www.zhangxinxu.com/wordpress/2021/11/js-visibilitychange-pagehide-lifecycle/
// };

export { pageViewPlugin as default };
